import { EventLinkTypes } from "@/constants/event";

export const enum ButtonTestIds {
    CHECKBOX_OPTION = "checkbox-option",
    RADIO_OPTION = "radio-option",
    EMAIL_SUBSCRIBE_AGREE = "email-subscribe-sure-button",
    EMAIL_SUBSCRIBE_DECLINE = "email-subscribe-decline-button",
    UPGRADE_SUB_DONT_TAKE_DISCOUNT = "upgrade-sub-refuse-discount-button",
    CONTINUE = "continue-button",
}

export const enum ContainerTestIds {
    PLAN_ITEM = "plan-item-container",
    MAIN = "main-quiz-container",
}

export const enum FooterLinkTestIds {
    REFUND_POLICY = "footer-link-refund-policy",
    PRIVACY_POLICY = "footer-link-privacy-policy",
    TERMS_OF_USE = "footer-link-terms-of-use",
    SUPPORT_LINK = "footer-link-support-link",
    FAQ = "footer-link-faq",
}

export const getFooterLinkTestId = (type: EventLinkTypes): FooterLinkTestIds => {
    switch (type) {
        case EventLinkTypes.privacyPolicy:
            return FooterLinkTestIds.PRIVACY_POLICY;
        case EventLinkTypes.refundPolicy:
            return FooterLinkTestIds.REFUND_POLICY;
        case EventLinkTypes.termsOfUse:
            return FooterLinkTestIds.TERMS_OF_USE;
        case EventLinkTypes.supportLink:
            return FooterLinkTestIds.SUPPORT_LINK;
        case EventLinkTypes.faq:
            return FooterLinkTestIds.FAQ;
        default: {
            const _exhaustive: never = type;
            return _exhaustive;
        }
    }
};

export const enum LabelTestIds {
    PAYMENT_PLAN_NAME = "payment-plan-name-label",
    PAYMENT_PLAN_OLD_PRICE = "payment-plan-old-price-label",
    PAYMENT_PLAN_TARGET_PRICE = "payment-plan-target-price-label",
    PRICE_WHOLE_PART = "price-whole-label",
    PRICE_FRACTIONAL_PART = "price-fractional-label",
    PRICE_OLD_VALUE = "price-old-value-label",
}

export const getButtonTestIdByText = (text: string) => {
    return `${text.toLocaleLowerCase().split(" ").join("-")}-button`;
};

export const getRadioTestIdByText = (text: string) => {
    return `${text.toLocaleLowerCase().split(" ").join("-")}-option`;
};

export const getCheckboxTestIdByText = (text: string) => {
    return `${text.toLocaleLowerCase().split(" ").join("-")}-option`;
};
